export const CLOSE_WHATS_NEW_DIALOG = 'CLOSE_WHATS_NEW_DIALOG'
export const OPEN_WHATS_NEW_DIALOG = 'OPEN_WHATS_NEW_DIALOG'

export const closeWhatsNewDialog = () => ({ type: CLOSE_WHATS_NEW_DIALOG })
export const openWhatsNewDialog = () => ({ type: OPEN_WHATS_NEW_DIALOG })
